export default "__VITE_ASSET__9b66047d__"